/* Hooks */
import useAuth from "../../../hooks/useAuth";
import {useEffect, useState} from "react";
/* Helpers */
import { emailsOrder } from "../../../helper/orders";
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
/* API Context */
import {getAdminEmailList} from "../../../api/admin/emailReq";
import usePager from "../../../hooks/usePager";


export default function Emails() {
    const sources = "fas fa-at";
    const [ emailList, setEmailList ] = useState();
    const { currentPage, setCurrentPage, itemsPerPage, totalPages, setTotalPages } = usePager();
    const { auth } = useAuth();
    const token = auth.token;
    const [ totalItems, setTotalItems ] = useState();

    const apiEmailList = async () => {
        const response = await getAdminEmailList(token, currentPage, itemsPerPage);
        setEmailList(response?.emailList);
        setTotalItems(response?.totalItems);
    }

    useEffect(() => {
        setCurrentPage(1)
        setTotalPages(Math.ceil(totalItems / itemsPerPage))
    }, [ totalItems, itemsPerPage ]);

    useEffect(() => {
        apiEmailList();
    }, [ itemsPerPage, currentPage, totalPages, totalItems ]);

    return (
        <main className="admin">
            <Header parent="Administration"
                    location="Emails"
                    slug="/admin/accueil"
            />
            <div className="content-container">
                <Icon source={ sources } color="blue" span="Liste des Emails"/>
                <div className="dashboard">
                    <Dashboard location="Emails" dataObject={ emailList || [] } order={ emailsOrder } />
                </div>
            </div>
        </main>
    )
}